<template>
    <section id="intro2" class="overflow-hidden">
        <div class="container">
            <div class="row">
                <div class="col-12 my-5 d-block"><h3 class="text-title-content text-secondary wow slideInDown">{{SectionIntro2.title}}</h3></div>
                <div class="col-10 text-content h-100 mb-4 wow slideInLeft" data-wow-delay="1s">
                    <p>{{SectionIntro2.desc}}</p><br>
                    <p>{{SectionIntro2.desc2}}</p>
                    <ul class="green">
                        <li>{{SectionIntro2.lists1}}</li>
                        <li>{{SectionIntro2.lists2}}</li>
                        <li>{{SectionIntro2.lists3}}</li>
                        <li>{{SectionIntro2.lists4}}</li>
                    </ul>
                </div>
                <div class="col-2">
                    <div class="sun-icon-gold animated pulse infinite" data-wow-delay="0.6s"></div>
                    <div class="jargen5 wow slideInRight"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import axios from 'axios'

export default {
  name: 'SectionIntro2',

  data(){
   return{
     lastScrollPosition: 0,
     SectionIntro2:{
         title: null,
         desc: null,
         desc2: null,
         lists1: null,
         lists2: null,
         lists3: null,
         lists4: null
         }
   }
 },

  mounted(){
    axios.get(`../../lang.json`).then(response => {
            let dataSectionIntro2
            if (localStorage.getItem('lang_nad') == 'id'){
                dataSectionIntro2 = response.data.id[0];
            } else if(localStorage.getItem('lang_nad') == 'en'){
                dataSectionIntro2 = response.data.en[0];
            }
            this.SectionIntro2.title = dataSectionIntro2.SectionIntro2.title
            this.SectionIntro2.desc = dataSectionIntro2.SectionIntro2.desc
            this.SectionIntro2.desc2 = dataSectionIntro2.SectionIntro2.desc2
            this.SectionIntro2.lists1 = dataSectionIntro2.SectionIntro2.lists1
            this.SectionIntro2.lists2 = dataSectionIntro2.SectionIntro2.lists2
            this.SectionIntro2.lists3 = dataSectionIntro2.SectionIntro2.lists3
            this.SectionIntro2.lists4 = dataSectionIntro2.SectionIntro2.lists4
            })

    window.addEventListener('scroll', this.onScroll)
  }
}
</script>
